/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as _ from 'lodash';
import { Redirect } from 'react-router';

import ContentFrame from '../../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';

import Card, { CardSection, EmptyCard } from '../../../components/card/Card';
import UnverifiedEmailControl from './UnverifiedEmailControl';

import { UserData } from '../../../../models/UserModel';
import Spacer from '../../../components/Spacer';
import RouteNames from '../../RouteNames';
import UserService from '../../../../apiServices/UserService';
import ContentWrapper from '../../../components/ContentWrapper';

interface Props {
  userData: UserData;
  onCancel(): void;
  onChangeEmail(): void;
}

class VerifyEmail extends React.Component<Props, {}> {
  componentDidMount() {
    const { userData } = this.props;
    UserService.verifyEmail(userData.id);
  }

  render() {
    const { onCancel, userData, onChangeEmail } = this.props;

    if (userData.email_verified) { return <Redirect to={RouteNames.myBackpack()} />; }

    const hasPendingEmail = !!userData.pending_email;
    const headingPhrase = hasPendingEmail ? { id: 'verifyEmail.pendingEmail.heading' } : { id: 'verifyEmail.currentEmail.heading' };

    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            cancel={onCancel}
            submit={null}
            color="white"
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableText id="verifyEmail.title.text" />
              <ContentWrapper>
                <Card>
                  <CardSection
                    isTopCard
                    hasBorder
                    className={hasPendingEmail ? 'profile-background-color-10' : null}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                  >
                    <UnverifiedEmailControl
                      titlePhrase={headingPhrase}
                      userData={userData}
                      onCancel={onCancel}
                      goToChangeEmail={onChangeEmail}
                    />
                  </CardSection>

                  <CardSection className="font-color-gsMedDark font-footnote" hasBorder={false}>
                    <FormattedMessage id="verifyEmail.message.text" />
                  </CardSection>
                </Card>

                <Spacer size="4" />

                <EmptyCard className="font-subhead font-color-gsMedDark">
                  <FormattedMessage id="verifyEmail.spam.message.text" />
                </EmptyCard>
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}

export default VerifyEmail;
